import {
  BrowserRouter,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import "./components/Auth/Auth.css";
import Login from "./pages/auth/Login";
import "./components/Auth/Auth.css";
import Otp from "./pages/auth/Otp";
import AutomaticData from "./pages/auth/AutomaticData";
import ManualData from "./pages/auth/ManualData";
import Dashboard from "./pages/user/Dashboard";
import AdminDashboard from "./pages/admin/AdminDashboard";
import IncentiveClaimApplication from "./pages/user/IncentiveClaimApplication";
import ApplyIncentiveClaimApplication from "./pages/user/ApplyIncentiveClaimApplication";
import DraftApplications from "./pages/user/DraftApplications";
import AppliedApplications from "./pages/user/AppliedApplications";
import ApprovedApplicatons from "./pages/user/ApprovedApplicatons";
import Profile from "./pages/user/Profile";
import PrivateRoute from "./components/common/PrivateRoute";
import ApplicationTransactions from "./pages/user/ApplicationTransactions";
import AdminLogin from "./pages/auth/AdminLogin";
import AdminUsersDashboard from "./pages/admin/AdminUsers";
import DLTCApplications from "./pages/admin/DLTCApplications";
import CTTCApplications from "./pages/admin/CTTCApplications";
import TIFCApplications from "./pages/admin/TIFCApplications";
import CancelApplications from "./pages/admin/CancelApplications";
import ApprovedApplications from "./pages/admin/ApprovedApplications";
import AllApplications from "./pages/admin/AllApplications";
import NewApplications from "./pages/admin/NewApplications";
import PendingApplications from "./pages/admin/PendingApplications";
import AddNewTransaction from "./pages/admin/AddNewTransaction";
import AdminTransactions from "./pages/admin/AdminTransactions";
import NodalOfficers from "./pages/admin/NodalOfficers";
import EditNodalOfficer from "./pages/admin/EditNodalOfficer";
import NavigationProvider from "./components/NavigationProvider.jsx/NavigationProvider";
import ApplicationView from "./pages/admin/ApplicationView";
import Configuration from "./pages/admin/Configurations";
import ApplicationDraft from "./pages/user/ApplicationDraft";
import UserDetails from "./pages/admin/UserDetails";
import AdminNotifications from "./pages/admin/AdminNotifications";
import DDOApplications from "./pages/admin/DDOApplications";
import IncompleteDocumentPendingApplications from "./pages/admin/IncompleteDocumentPendingApplications";
import IncompleteInformationApplications from "./pages/admin/IncompleteInformationApplications";
import TIFCVerifiedApplications from "./pages/admin/TIFCVerifiedApplications";
import DLCTUnverifiedApplications from "./pages/admin/DLCTUnverifiedApplications";
import DLCTVerifiedApplications from "./pages/admin/DLCTVerifiedApplications";
import SLACRejectedApplications from "./pages/admin/SLACRejectedApplications";
import Home from "./pages/auth/Home";
import PrayatanYojna from "./pages/auth/PrayatanYojna";
import VeerChandYojana from "./pages/auth/VeerChandYojana";
import DeenDayalYojana from "./pages/auth/DeenDayalYojana";
import TourismPolicy2023 from "./pages/auth/TourismPolicy2023";
import TIFCFaciliation from "./pages/auth/TIFCFaciliation";
import PaymentDoneApplicaitons from "./pages/admin/PaymentDoneApplicaitons";
import PaymentDone from "./pages/user/PaymentDone";
import ResetPassword from "./pages/admin/ResetPassword";
import DLCTOfficers from "./pages/admin/DLCTOfficers";
import NodalPendingApplications from "./pages/admin/NodalPendingApplications";
import OfficersPendingApplications from "./pages/admin/OfficersPendingApplications";
import UserPendingApplications from "./pages/admin/UserPendingApplications";
import ApplicationPrint from "./components/common/ApplicationPrint";
import { LanguageProvider } from "./components/LanguageProvider/LanguageProvider";
import { useEffect } from "react";
import { AuthProvider } from "./components/Auth/AuthProvider";
import NodalIncompleteInformationApplications from "./pages/admin/NodalIncompleteInformationApplications";

function App() {
  useEffect(() => {
    const disableRightClick = (event) => {
      event.preventDefault(); // Prevent the default right-click menu
    };

    const disableDevTools = (event) => {
      // Check for F12 key or specific key combinations
      if (
        event.key === "F12" || // F12
        (event.ctrlKey &&
          event.shiftKey &&
          (event.key === "I" || event.key === "J" || event.key === "C")) || // Ctrl+Shift+I/J/C
        (event.ctrlKey && event.key === "U") || // Ctrl+U (View Source)
        (event.ctrlKey && event.shiftKey && event.key === "U") || // Ctrl+Shift+U (View Source in some browsers)
        (event.altKey && event.shiftKey && event.key === "I") || // Alt+Shift+I (DevTools in some browsers)
        (event.ctrlKey && event.shiftKey && event.key === "K") || // ctrl+shirt+k (DevTools in firefox)
        (event.ctrlKey && event.shiftKey && event.key === "E") // ctrl+shirt+E (DevTools in firefox)
      ) {
        event.preventDefault();
      }
    };

    document.addEventListener("contextmenu", disableRightClick); // Disable right-click
    document.addEventListener("keydown", disableDevTools); // Disable F12 and DevTools shortcuts

    // Cleanup the event listeners on component unmount
    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableDevTools);
    };
  }, []);

  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
          <NavigationProvider>
            <PrivateRoute roles={["superadmin", "admin", "user"]}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/prayatan-yojana" element={<PrayatanYojna />} />
                <Route
                  path="/veer-chand-yojana"
                  element={<VeerChandYojana />}
                />
                <Route
                  path="/deen-dayal-yojana"
                  element={<DeenDayalYojana />}
                />
                <Route
                  path="/tourism-policy-2023"
                  element={<TourismPolicy2023 />}
                />
                <Route path="/tifc-faciliation" element={<TIFCFaciliation />} />
                <Route path="/login" element={<Login />} />
                <Route path="/validate-otp" element={<Otp />} />
                <Route path="/automatic-data" element={<AutomaticData />} />
                <Route path="/manual-data" element={<ManualData />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route
                  path="/apply-incentive-claim"
                  element={<ApplyIncentiveClaimApplication />}
                />
                <Route
                  path="/incentive-claim-form/:applicationId"
                  element={<IncentiveClaimApplication />}
                />
                <Route
                  path="/draft-applications"
                  element={<DraftApplications />}
                />
                <Route
                  path="/applied-applications"
                  element={<AppliedApplications />}
                />
                <Route
                  path="/approved-applications"
                  element={<ApprovedApplicatons />}
                />
                <Route
                  path="/payment-done-applications"
                  element={<PaymentDone />}
                />
                <Route
                  path="/application-transactions"
                  element={<ApplicationTransactions />}
                />
                <Route path="/user-profile" element={<Profile />} />
                <Route path="/notifications" element={<Profile />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route
                  path="/admin/registered-users"
                  element={<AdminUsersDashboard />}
                />
                <Route
                  path="/admin/tifc/applications"
                  element={<TIFCApplications />}
                />
                <Route
                  path="/admin/dlct/applications"
                  element={<DLTCApplications />}
                />
                <Route
                  path="/admin/slac/applications"
                  element={<CTTCApplications />}
                />
                <Route
                  path="/admin/ddo/applications"
                  element={<DDOApplications />}
                />
                <Route
                  path="/admin/cancel-applications"
                  element={<CancelApplications />}
                />
                <Route
                  path="/admin/approved-applications"
                  element={<ApprovedApplications />}
                />
                <Route
                  path="/admin/payment-done-applications"
                  element={<PaymentDoneApplicaitons />}
                />
                <Route
                  path="/admin/all-applications"
                  element={<AllApplications />}
                />
                <Route
                  path="/admin/new-applications"
                  element={<NewApplications />}
                />
                <Route
                  path="/admin/nodal-incomplete-information-applications"
                  element={<NodalIncompleteInformationApplications />}
                />
                <Route
                  path="/admin/incomplete-document-pending-applications"
                  element={<IncompleteDocumentPendingApplications />}
                />
                <Route
                  path="/admin/incomplete-information-applications"
                  element={<IncompleteInformationApplications />}
                />
                <Route
                  path="/admin/tifc-verified-applications"
                  element={<TIFCVerifiedApplications />}
                />
                <Route
                  path="/admin/dlct-unverified-applications"
                  element={<DLCTUnverifiedApplications />}
                />
                <Route
                  path="/admin/dlct-verified-applications"
                  element={<DLCTVerifiedApplications />}
                />
                <Route
                  path="/admin/rejected-applications"
                  element={<SLACRejectedApplications />}
                />

                <Route
                  path="/admin/pending-applications"
                  element={<PendingApplications />}
                />
                <Route
                  path="/admin/nodal-pending-applications"
                  element={<NodalPendingApplications />}
                />
                <Route
                  path="/admin/officer-pending-applications"
                  element={<OfficersPendingApplications />}
                />
                <Route
                  path="/admin/user-pending-applications"
                  element={<UserPendingApplications />}
                />
                <Route
                  path="/admin/add-new-transaction"
                  element={<AddNewTransaction />}
                />
                <Route
                  path="/admin/transactions"
                  element={<AdminTransactions />}
                />
                <Route
                  path="/admin/state-officers"
                  element={<NodalOfficers />}
                />
                <Route
                  path="/admin/district-officers"
                  element={<DLCTOfficers />}
                />
                <Route
                  path="/admin/officers/:name"
                  element={<EditNodalOfficer />}
                />
                <Route
                  path="/admin/user/change-password"
                  element={<ResetPassword />}
                />
                <Route
                  path="/admin/application-view"
                  element={<ApplicationView />}
                />
                <Route
                  path="/admin/configurations"
                  element={<Configuration />}
                />
                <Route
                  path="/application-draft/:applicationId"
                  element={<ApplicationDraft />}
                />
                <Route
                  path="/application-print/"
                  element={<ApplicationPrint />}
                />
                <Route path="/admin/user-details" element={<UserDetails />} />
                <Route
                  path="/admin/notifications"
                  element={<AdminNotifications />}
                />
              </Routes>
            </PrivateRoute>
          </NavigationProvider>
        </BrowserRouter>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
